import { useAuth } from '../../auth/core/Auth'
import { resolveEffectiveBehaviorType } from '../../Management/core/adminActorContext'

export type CrewingRoleAccess = {
  isSuperAdmin: boolean
  isCrew: boolean
  isOfficeRole: boolean
  isCompanyGroupAdmin: boolean
  isCompanyAdmin: boolean
  isOperator: boolean
  isCustomRole: boolean
  effectiveBehavior: string
  hasPermission: (code: string) => boolean
}

export function resolveCrewingRoleAccess(
  currentUser: any,
  roleDetails?: any,
  tenant?: any,
  isSuperAdmin?: boolean,
  hasPermission?: (code: string) => boolean
): CrewingRoleAccess {
  const role = currentUser?.role
  const roleId = Number(role?.id ?? 0)
  const resolvedBehavior = resolveEffectiveBehaviorType(currentUser, { roleDetails, tenant })
  const directTemplate = String(
    role?.effectiveBehaviorType ??
    role?.behavioralTemplate ??
    role?.baseRoleType ??
    roleDetails?.effectiveBehaviorType ??
    roleDetails?.behavioralTemplate ??
    roleDetails?.baseRoleType ??
    ''
  ).trim().toUpperCase()

  const behavior = directTemplate || resolvedBehavior
  const isCustomRole = Boolean(
    role?.customRole ||
    (role?.roleType && String(role.roleType).toUpperCase().startsWith('CUSTOM')) ||
    (role?.roleName && String(role.roleName).toUpperCase().startsWith('CUSTOM'))
  )

  // Crew is someone assigned the CREW role (roleId 4 or behavior CREW)
  const isCrew = roleId === 4 || behavior === 'CREW'

  const isCompanyGroupAdmin = roleId === 5 || behavior === 'COMPANY_GROUP_ADMIN'
  const isCompanyAdmin = roleId === 2 || behavior === 'COMPANY_ADMIN'
  const isOperator = roleId === 6 || behavior === 'OPERATOR'

  // An office role is any non-vessel staff: Super Admin, CGA, CA, Operator, Superintendent, or any non-crew Custom Role
  const isOfficeRole =
    Boolean(isSuperAdmin) ||
    isCompanyGroupAdmin ||
    isCompanyAdmin ||
    isOperator ||
    behavior === 'SUPERINTENDENT' ||
    (!isCrew && isCustomRole) ||
    !isCrew

  return {
    isSuperAdmin: Boolean(isSuperAdmin),
    isCrew,
    isOfficeRole,
    isCompanyGroupAdmin,
    isCompanyAdmin,
    isOperator,
    isCustomRole,
    effectiveBehavior: behavior,
    hasPermission: hasPermission || (() => false),
  }
}

export function useCrewingRoleAccess(): CrewingRoleAccess {
  const { currentUser, roleDetails, tenant, isSuperAdmin, hasPermission } = useAuth()
  return resolveCrewingRoleAccess(currentUser, roleDetails, tenant, isSuperAdmin, hasPermission)
}

